import { NgClass, DecimalPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { GridService } from 'app/Shared/Services/grid.service';
import { ConfirmationService } from 'primeng/api';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { map, Subscription } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { UserService } from 'app/Shared/Services/user.service';
import { Router } from '@angular/router';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { StatBoxComponent } from '../stat-box/stat-box.component';

@Component({
  selector: 'app-odr-summary',
  imports: [NgClass,ScrollPanelModule,DecimalPipe,MatProgressSpinner,StatBoxComponent],
  templateUrl: './odr-summary.component.html',
  styleUrl: './odr-summary.component.scss',
})
export class OdrSummaryComponent implements OnInit{
displayDivider:boolean =false;
 @Input('defaultFilters') DefaultFilterArray: any = [];
 pageName ="Tranasction_Summary"
 Limit:any
 isLoadingResults = true;
 orderSummaryDetails:any;
 topCustomers:any
 routeSummaryDetails:any;
 venueName:any;
 executionSummaryDetails:any;
 brokers:any
 orderCategary:any;
 RouteCategary:any;
 subscription!: Subscription;

constructor(
    public constantService: ConstantService,
    private emitterService:EmitterService,
    public confirmationService: ConfirmationService,
    private gridService:GridService,
    private userService: UserService,
    private router: Router
    
    
  ) { }

 ngOnInit() {
  this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
  }

 getData(filterArr?:any) {
  let FilterArray = filterArr ? filterArr : this.DefaultFilterArray;
  this.Limit = { 'Start': '0', 'End': 0 };
  this.isLoadingResults = true;
        this.gridService.prepareData(APIURL.ODR_Processed_Transactiions_Summary, FilterArray, this.Limit,"Tranasction_Summary")
          .pipe(map((response: Response) => {
            return response;
          }))
          .subscribe({
            next: (dataset: any) => {
              this.isLoadingResults = false;
              this.orderSummaryDetails = dataset.Data.OrderSummary;
              this.topCustomers=dataset.Data.OrderSummary?.topCustomers;
              this.routeSummaryDetails = dataset.Data.RouteSummary;
              this.venueName = dataset.Data.RouteSummary?.Venue;
              this.executionSummaryDetails = dataset.Data.ExecutionSummary;
              this.brokers = dataset.Data.ExecutionSummary?.executionsBrokers;
              this.orderCategary = dataset.Data.OrderCategorization;
              this.RouteCategary = dataset.Data.RouteCategorization;
            },
            error: (err: HttpErrorResponse) => {
            }
          });

  }
 
  openTransactionScreen(type: any, item: any) {
    let filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    let fromDate =  this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    let toDate =  this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    let trasactionType = type;
    let value = item;
    
    if(value == ""){
      const url = this.router.serializeUrl(this.router.createUrlTree(['Rsms/pages/Reg-Reporting/Order-Details'],
        {
          queryParams : {
            fromDate: fromDate,
            toDate: toDate,
            transactionType:trasactionType,
          }
        }
      ));
      window.open('#' + url, '_blank');
    }
    else{
     const url = this.router.serializeUrl(this.router.createUrlTree(['Rsms/pages/Reg-Reporting/Order-Details'],
        {
          queryParams : {
            fromDate: fromDate,
            toDate: toDate,
            transactionType:trasactionType,
            value: value
          }
        }
      ));
      window.open('#' + url, '_blank');
    }
  }

}
